import { getNestedPropertyOrDefault } from 'style-utils/core/createExtractCssFromProps/utils/getNestedPropertyOrDefault';
import { createParser } from '../createExtractCssFromProps/utils/createParser';
import css from '../css/css';
import { CSSObject } from 'styled-components';
import { ExtractCssFromPropsFn, StyledPropType } from '../core.types';

type VariantPropertyType = string | CSSObject | Record<string, StyledPropType>;

//Type ricorsivo per gestire le varianti annidate
//perchè lo style object può essere un oggetto con chiavi stringhe
//o un oggetto con chiavi stringhe che a loro volta contengono un oggetto con chiavi stringhe
//come per esempio un breakpoint object type
//e così via
type VariantObjectType = {
  [key: string]:
    | VariantPropertyType
    | { [key: string]: VariantPropertyType | VariantObjectType };
};

export const variant = ({
  scale,
  prop = 'variant',
  // enables new api
  variants = {},
  // shim for v4 API
  key,
}: {
  scale?: string;
  prop?: string;
  variants?: VariantObjectType;
  key?: string;
}) => {
  let sx: ExtractCssFromPropsFn;
  if (Object.keys(variants).length) {
    sx = (value, scale, props) =>
      css(getNestedPropertyOrDefault(scale, value, null))(props?.theme);
  } else {
    sx = (value, scale) => getNestedPropertyOrDefault(scale, value, null);
  }
  sx.scale = scale || key;
  sx.defaults = variants;
  const config = {
    [prop]: sx,
  };
  const parser = createParser(config);
  return parser;
};

export default variant;
